<template>
  <div class="option-picker" :class="{ 'option-picker--disable': disable }" ref="dropdown">
    <button
      @click="onShowDropdown"
      type="button"
      class="option-picker__checked"
      :disabled="!isInteractive"
      :aria-expanded="isInteractive && is_dropdown_show ? 'true' : 'false'"
      :style="{ backgroundColor: value ? value.color : '#d5d5d5' }"
    >
      <span v-if="value">
        {{ value.name }}{{ value.amount_required ? `: ${amount.toLocaleString()}$` : '' }}
      </span>
      <span v-else>None</span>
    </button>
    <div v-if="is_dropdown_show && options.length" class="option-picker__dropdown">
      <div class="option-picker__dropdown-inner">
        <div class="option-picker__list">
          <button
            @click="onColorClick(option)"
            v-for="option in options"
            :key="option.code"
            :style="{ backgroundColor: option.color }"
            :class="{ 'option-picker__item--checked': value ? option.code === value.code : '' }"
            class="option-picker__item"
            type="button"
          >
            {{ option.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppOptionPicker',
  model: {
    prop: 'value',
    event: 'click'
  },
  props: {
    value: Object,
    options: Array,
    disable: {
      type: Boolean,
      default: false
    },
    amount: Number,
    default: null
  },
  data() {
    return {
      is_dropdown_show: false
    }
  },
  computed: {
    isInteractive() {
      return !this.disable && Boolean(this.options && this.options.length)
    }
  },
  created() {
    window.addEventListener('click', this.handleClick)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.handleClick)
  },
  methods: {
    handleClick(e) {
      if (!this.$refs.dropdown.contains(e.target)) this.is_dropdown_show = false
    },
    onColorClick(option) {
      if (!this.value) this.$emit('click', option)
      else if (this.value.code !== option.code) this.$emit('click', option)
      else this.$emit('click', null)
      this.is_dropdown_show = false
    },
    onShowDropdown() {
      if (!this.isInteractive) return
      this.is_dropdown_show = !this.is_dropdown_show
    }
  }
}
</script>

<style lang="sass" scoped>
.option-picker
  position: relative
  display: inline-block
  min-width: max-content

.option-picker--disable
  pointer-events: none

.option-picker__checked
  padding: 4px 14px 5px
  border-radius: 20px

  &:disabled
    cursor: default

  span
    color: #fff
    font-size: 13px
    font-weight: 500

.option-picker__dropdown
  position: absolute
  left: 0
  top: calc(100% + 6px)
  overflow: hidden
  z-index: 3
  border: 1px solid #dfdfdf
  border-radius: 9px
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1)
  background-color: #fff

.option-picker__dropdown-inner
  max-height: 180px
  padding: 10px
  overflow: hidden auto
  scrollbar-color: $color-theme #f2f3f8
  scrollbar-width: thin

  &::-webkit-scrollbar
    width: 2px

  &::-webkit-scrollbar-track
    border-radius: 5px
    background-color: #f2f3f8

  &::-webkit-scrollbar-thumb
    border-radius: 5px
    background-color: $color-theme

.option-picker__list
  display: flex
  flex-direction: column
  align-items: flex-start
  gap: 10px

.option-picker__item
  min-width: max-content
  padding: 5px 15px
  border-radius: 20px
  color: #fff
  text-align: left
  font-size: 13px
  font-weight: 500

.option-picker__item--checked
  opacity: 0.7
  pointer-events: none

.option-picker__checked:not(:disabled),
.option-picker__item:not(.option-picker__item--checked)
  cursor: pointer
  transition: filter 150ms ease, box-shadow 150ms ease

  &:hover
    filter: brightness(0.9)
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16)

  &:focus-visible
    outline: 2px solid $color-text-base
    outline-offset: 2px

@media (prefers-reduced-motion: reduce)
  .option-picker__checked,
  .option-picker__item
    transition: none
</style>
